// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Policy } from '../../../../types/policy';

export type PensionSubType = 'DB' | 'DC';

const DC_NAME_PATTERNS = [
  /\bprsa\b/i,
  /defined\s+contribution/i,
  /occupational\s+pension/i,
  /executive\s+pension/i,
  /personal\s+pension/i,
  /personal\s+retirement\s+bond/i,
  /\bprb\b/i,
  /buy[- ]?out\s+bond/i,
  /vested\s+prsa/i,
  /approved\s+retirement\s+fund/i,
  /\barf\b/i,
  /\bavc\b/i,
  /mastertrust/i,
  /director'?s?\s+pension/i,
];

export function isPensionPolicy(policy: Pick<Policy, 'category'>): boolean {
  return (policy.category ?? '').toUpperCase() === 'PENSION';
}

export function classifyPensionPolicy(
  policy: Partial<Pick<Policy, 'policyTypeName' | 'policyType'>>,
  pensionTypeLabel?: string | null,
): PensionSubType {
  const name = policy.policyTypeName || policy.policyType || pensionTypeLabel || '';
  return DC_NAME_PATTERNS.some((rx) => rx.test(name)) ? 'DC' : 'DB';
}
